import React, { useState } from 'react'
import { Button, Col, Container, Image, Modal, Row } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
//import IIT_logo from "../assets/iitkgpmain.jpeg";
import careerlogo from "../assets/careercounselling.png";
import { Card } from "react-bootstrap";
import { FaGlobeAsia, 
  FaBrain, 
  FaAtom, 
  FaShieldAlt, 
  FaSatellite, 
  FaNetworkWired, 
  FaDatabase,
  FaBolt,
  FaLeaf,
  FaMobileAlt,
  FaSatelliteDish,
  FaRobot
} from "react-icons/fa";
const AboutInstitute = () => {
   const navigate = useNavigate(); 
     const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
    <section className="py-5 bg-light" id="about-institute">
      <Container>
          <h1 className="fw-bold mb-3 text-center text-primary ">
              About Our Research & Training Institute
            </h1> <hr/>
        <Row className="align-items-center">
          {/* Left Column - Text Content */}
          <Col md={7} className="mb-4 mb-md-0">
          
            <p className="text-muted">
              At <strong className="fw-bold text-success" >Olewin Academy </strong>, we are redefining the boundaries of
              scientific learning, innovation, and research training. As a{" "}
              <strong className="text-warning fw-bold">Centre of </strong> <strong className="text-primary fw-bold"> Excellence </strong>, we provide in-depth and interdisciplinary
              training across research, industrial, and academic domains—empowering students,
              scholars, and professionals to become the next generation of innovators and leaders.
            </p>

            <p className="text-muted">
              Our programs integrate cutting-edge research, advanced technologies, and real-world
              applications to bridge the gap between theory and practice. Whether it’s preparing for
              competitive research careers, mastering new technologies, or contributing to global
              collaborations, our learners gain both the knowledge and hands-on expertise required
              to excel.
            </p>

            <p className="text-muted">
              We collaborate with leading universities, research organizations, and industries to
              offer project-based training, internships, and research fellowships in diverse
              domains such as:
            </p>

            <ul className="text-muted ms-3">
              <li>Space technologies & Satellite Modules</li>
              <li>Quantum Computing & Artificial Intelligence</li>
              <li>BlockChain technology & web 3.0 Applications</li>
              <li>GeoSciences, Earth Observation Technologies</li>
              <li>Energy, Environment & Sustainability Studies</li>
              <li>Advanced Data Sciences/Analytics & Machine Learning</li>
              <li>Biomedical & Life Sciences Research</li>
              <li>Innovation & Emerging Technologies</li>
            </ul>

            <p className="text-muted">
              As a recognized research sponsor and training partner, our institute proudly supports{" "}
              <strong>international scientific events</strong> held in{" "}
              <em>India, Singapore, Mexico</em>, and other global research hubs—fostering
              cross-border collaboration and knowledge exchange.
            </p>

            <p className="fw-semibold text-dark mt-3">
              <FaGlobeAsia className="text-primary me-2" />
              “Empowering Research, Innovation, and Global Collaboration for a Better Tomorrow.”
            </p>
          </Col>

          {/* Right Column - Image and Founder Section */}
          <Col md={5} className="text-center">
            <Image
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTShqTJ8eHDcao0aojXj1V6a8u2SPFhDGkqoQ&s"
              alt="Research Institute"
              fluid
              rounded
              className="shadow-lg mb-3 w-auto rounded-3 "
            />
            <p  style={{ fontSize: "0.7rem", color: "#6e6e6ea5", }}>
 <span className='text-danger'>Disclaimer: </span> The IIT Kharagpur building image is used only to represent the founder’s alumni status. 
  All rights and intellectual property belong to IIT Kharagpur.
</p>

  <Button
        variant="outline-secondary"
        size="sm"
        onClick={handleShow}
        style={{ borderRadius: "8px" }}
      >
        View Policy
      </Button>

      <Modal show={show} onHide={handleClose} centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Disclaimer & Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.9rem", textAlign: "justify" }}>
          <p>
            The image displayed of the IIT Kharagpur Administrative Building is
            used solely for representational purposes to highlight the founder’s
            alumni association with the institute. This use does not imply any
            partnership, endorsement, affiliation, or authorization from IIT
            Kharagpur.
          </p>
          <p>
            All images, logos, and related trademarks of IIT Kharagpur remain
            the exclusive property of the Indian Institute of Technology
            Kharagpur. The Olewin Academy acknowledges and respects the
            intellectual property rights of IIT Kharagpur and has used the image
            purely for illustrative and educational reference.
          </p>
          <p>
            This usage is non-commercial, intended only to display the academic
            background of the founder and does not claim any ownership or
            official representation of IIT Kharagpur or its entities.
          </p>
          <p>
            By viewing this content, you acknowledge that Olewin Academy is an
            independent organization and not affiliated, endorsed, or sponsored
            by IIT Kharagpur in any form.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

            <Card className="border-0 p-3 mt-2">
              <Card.Body>
                <div className="d-inline-block position-relative">
                    <img 
                    src="https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/Mahesh_photo.png"
                    // src="https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/mahesh.png"
                      alt="Professor Bandaru Mahesh" 
                      className="profile-img w-50 h-50 rounded-circle shadow"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextElementSibling.style.display = 'flex';
                      }}
                    />
                  </div>
                <Card.Title className="fw-bold mb-1 py-3 fs-6 my-3">Core Professor / Career Counselling Instructor</Card.Title>
                <Card.Text className="mb-0 fw-bold text-primary fs-3">Bandaru Mahesh</Card.Text>
                <Card.Text className="text-muted fw-bold">IIT Kharagpur Alumnus <br/> International Sponsor, Quantum Computing& Space tech(Satellite System Architecture) Specialist, Energy Systems Developer & More .....</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
     <section className="py-2 bg-light" id="centre-of-excellence">
      <Container>
        {/* Title */}
        <div className="text-center mb-2">
                <h1 className="text-center  mb-1 fw-bold text-warning text-uppercase">
             Centre of {" "}
              <span className="text-center fw-bold text-success">Excellence (CoE)</span>
           
            </h1>
          <p className="text-muted fs-6">
            Empowering Innovation through Education — Aligned with National
            Missions of the Government of India
          </p>
        </div>

        {/* Overview and Image */}
        <Row className="align-items-center mb-2">
          <Col md={6} className="mb-4 mb-md-0">
            <img
              src={careerlogo}
              alt="Government of India Emblem"
              className="img-fluid rounded shadow-sm"
              style={{ maxHeight: "250px", objectFit: "contain" }}
            />
          </Col>
          <Col md={6}>
            <p className="text-secondary" style={{ textAlign: "justify" }}>
              The Olewin Academy Centre of Excellence (CoE) is envisioned as a
              collaborative innovation hub aligned with the Government of
              India’s <strong>Digital India</strong>, <strong>Skill India</strong>,
              and <strong>NEP 2020</strong> initiatives. It bridges academia,
              industry, and government efforts by offering high-impact
              training, internships, and mentorship in emerging technologies.
            </p>
          </Col>
        </Row>

        {/* Focus Areas */}
        <h4 className="fw-semibold text-center mb-3 text-dark">
          Key Focus Areas
        </h4>
        <Row xs={1} md={3} className="g-4 mb-5">
  {[
        { title: "Space Science & Satellite Technology", icon: <FaSatelliteDish className="fs-1 text-warning" /> },
    { title: "Artificial Intelligence & Machine Learning", icon: <FaRobot className="fs-1 text-success" /> },
    { title: "Quantum Computing & Advanced Materials", icon: <FaAtom className="fs-1 text-dark" /> },
    { title: "Cybersecurity & Ethical Hacking", icon: <FaShieldAlt className="fs-1 text-danger" /> },
        { title: "BlockChian Technology & Web 3.0", icon: <FaNetworkWired className="fs-1 text-primary" /> },
    { title: "Internet of Things (IoT)", icon: <FaMobileAlt className="fs-1 text-secondary" /> },
    { title: "Data Science & Big Data Analytics", icon: <FaDatabase className="fs-1 text-dark" /> },
    { title: "Energy Sector & Renewable Systems", icon: <FaBolt className="fs-1 text-success" /> },
    { title: "Sustainable & Green Energy", icon: <FaLeaf className="fs-1 text-success" /> },
  ].map((area, index) => (
    <Col key={index}>
      <Card className="h-100 text-center border-0 shadow-sm p-3">
        <div className="mb-3">{area.icon}</div>
        <Card.Body>
          <Card.Title className="fs-6 fw-semibold">{area.title}</Card.Title>
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>

        {/* Government & Career Counselling Section */}
        <Row className="align-items-center mb-4">
          <Col md={12}>
            <h5 className="fw-bold text-dark">
              Career Counselling & Government Collaboration
            </h5>
            <p className="text-secondary" style={{ textAlign: "justify" }}>
              Our academy supports government-inspired initiatives such as
              <strong> AICTE Career Counselling</strong>,
              <strong> FutureSkills PRIME (MeitY)</strong>,
              and <strong>Skill India (NSDC)</strong>. We provide
              personalized guidance, access to national scholarship programs,
              and insights into emerging research opportunities aligned with
              India’s innovation ecosystem.
            </p>
          </Col>
          {/* <Col md={6} className="text-center">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Digital_India_logo.svg/1280px-Digital_India_logo.svg.png"
              alt="Digital India Logo"
              className="img-fluid rounded"
              style={{ maxHeight: "180px", objectFit: "contain" }}
            />
          </Col> */}
        </Row>

        {/* Call to Action */}
        <div className="text-center mt-5">
          <Button
            variant="success"
            size="md"
            className="rounded-pill px-5 py-2 fw-bold "
            onClick={() =>
              window.open(
                "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Brochure_olewinacademy.pdf",
                "_blank"
              )
            }
          >
            Explore CoE Programs Brochure
          </Button>
        </div>

        {/* Disclaimer */}
        <div className="text-center mt-4">
          <p className="text-muted small">
            *Disclaimer: The references to Government of India programs and
            missions are for educational and awareness purposes only. Olewin
            Academy is an independent educational initiative and is not
            directly affiliated with or endorsed by any government ministry or
            department.*
          </p>
        </div>
      </Container>
    </section>
    </>
  );
};

export default AboutInstitute;


